import { useEffect } from "react";
import { CargoDetails } from "./AgCargoDetails";
import { ContainerDetails } from "./AgContainerDetails";
import { ServiceOptIns } from "./AgServiceOptIns";
import { Container } from "../enquiry/enquiry-data";

export function Details({form,viewonly=false,applyDefault=true,sd=false}){
    
    const {getValues,watch,setValue} = form;
    const stuffing = watch("stuffingType")
 const deStuffing = watch("destuffingType")
  
 const outGuage = watch("showCargoDetailsOutGuage")
 const mode = watch("mode");
 const Scope = getValues("scope")
 const multidest = watch("multidest")
 const containerDetails = watch("containerDetails")
 const cartingorder = watch("cartingorder");
 const cartingorderdisable = watch("cartingorderdisable");
console.log("+++++++++++++++++++++++++++++97",cartingorderdisable)

   
  let showCargoDetail = false;
   
  if(mode.toLowerCase()==="lcl" || mode.toLowerCase()==="air" || (cartingorder!=undefined && cartingorder==true)){
    showCargoDetail = true;
  }else{
      let origin = Scope.split("-")[0];
      let destination = Scope.split("-")[2];
      if((origin?.toLowerCase()==="door" && stuffing.toLowerCase() === "dock" ) || (destination?.toLowerCase()==="door" && deStuffing.toLowerCase() === "dock" )){
          showCargoDetail = true;
      }else{
        showCargoDetail = false
      }
  }
  console.log("+++++++++++v1",multidest)
  console.log(" the scopre jhjbvbvygb yugv iyggvb yivuy gv uy ",Scope," ",mode," ",containerDetails," ",typeof(containerDetails)," ",containerDetails?.length>0 && containerDetails[0]['unit']!=undefined)

useEffect(()=>{
   if(!containerDetails || containerDetails.length==0){
    setValue("containerDetails",[new Container()])
   }
},[containerDetails])

useEffect(()=>{
   setValue("grandTotalWeight",0)
   setValue("grandTotalVolume",0)
   setValue("grandChargeable",0)
},[])

    return <div className="flex flex-col grow w-min-[876px] gap-2.5">
      <ServiceOptIns form={form} viewonly={viewonly} applyDefault={applyDefault} sd={sd}/>
         { Scope!="" && mode.toLowerCase() === "fcl" && containerDetails!=undefined && typeof(containerDetails)=='object' && containerDetails.length>0 && containerDetails[0]['unit']!=undefined && <ContainerDetails form={form} viewonly={viewonly} sd={sd}/>}
         {(multidest!=undefined && multidest.length>0)?<>{ Scope!="" && (showCargoDetail||outGuage)  && multidest[0]['cargoDetails']!=undefined && multidest[0]['cargoDetails'][0]['weight']!=undefined && typeof(multidest[0]['cargoDetails'][0]['weight'])=='object' && multidest[0]['cargoDetails'][0]['weight']['unit']!=undefined && <CargoDetails form={form} viewonly={cartingorderdisable!=undefined?cartingorderdisable:viewonly}/>}
      </>:""}
    </div>
}